import Chip from "@material-ui/core/Chip";
import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React from "react";
import { instance } from "../../../../Actions/AxiosInstance";
import If from "../../../../Component/Common/If";
import createstore from "../../../../store";
import { NoRecordFound } from "../EmpMainProfile/NoRecordFound";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  // dense: {
  //     marginTop: 16,
  // },
  colorSwitchBase: {
    color: "#166ab3",
    "&$colorChecked": {
      color: "#166ab3",
      "& + $colorBar": {
        backgroundColor: "#666",
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    "&$iOSChecked": {
      color: "#166ab3",
      backgroundColor: "#166ab3",
      "& + $iOSBar": {
        backgroundColor: "#666",
      },
    },
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: "translateX(15px)",
    "& + $iOSBar": {
      opacity: 1,
      border: "none",
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: "solid 1px",
    // borderColor: theme.palette.grey[400],
    // backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(45deg)",
  },

  educationGrades: [],
  allEducationalDetails: [],
});

class ReportingOffice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datareceived: false,
      hideButton: false,
      offices: [],
      flag: 0,
    };
    this.getViewComponent = this.getViewComponent.bind(this);
  }

  componentDidMount() {
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    // let employeeid = SubscriptionInfo.SubscriptionData.employeeid;
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      "",
    );
    let ShortDateFormat =
      typeof DateFormat === "string" ? DateFormat.split(" ") : [""];
    ShortDateFormat = ShortDateFormat[0];
    let employeeid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;

    let hideButton;
    colleagueid && colleagueid != employeeid
      ? (hideButton = true)
      : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        ShortDateFormat,
        colleagueid,
        hideButton,
      },
      () => {
        this.GetWorkRole();
      },
    );
  }

  GetWorkRole() {
    const data = {
      employeeid: this.state.colleagueid || this.state.employeeid,
      iscurrent: false,
    };

    instance
      .post("employee/empreportingoffice", data)
      .then((result) => {
        this.setState({ offices: result.data.result, datareceived: true });
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  getViewComponent() {
    const { offices } = this.state;
    return (
      <div>
        {offices.length > 0 ? (
          offices.map((item) => (
            <div className="profile-view-block">
              <div></div>
              <div className="width90 height90">
                <div className="position-rel">
                  <div className="address-data">{item.locationname} </div>
                </div>
                <div className="position-rel">
                  <div className="address-data">{item.addressline1} </div>
                </div>
                <div className="position-rel">
                  <div className="address-data">{item.cityname}</div>
                </div>
                <div className="position-rel">
                  <div className="address-data">{item.statename}</div>
                </div>
                <div className="position-rel">
                  <div className="address-data">{item.pincode}</div>
                </div>
                <div className="position-rel">
                  <div className="address-data">{item.countryname}</div>
                </div>
                <div>{item.iscurrent ? <Chip label="Current" /> : ""}</div>
              </div>
            </div>
          ))
        ) : (
          <div>
            <NoRecordFound />
          </div>
        )}
      </div>
    );
  }

  render() {
    const { datareceived } = this.state;
    return (
      <div>
        <If condition={datareceived}>{this.getViewComponent()}</If>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withSnackbar(ReportingOffice),
);
